export default window.location.hostname === 'localhost'
